// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: iBncYn8g8dso
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PermissionChip from "../../PermissionChip"; // plasmic-import: SruSaz4XhKEy/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicRolesCard.module.css"; // plasmic-import: iBncYn8g8dso/css
import Icons8EditSvgIcon from "./icons/PlasmicIcon__Icons8EditSvg"; // plasmic-import: 6f1pF63VMd4_/icon

createPlasmicElementProxy;

export const PlasmicRolesCard__VariantProps = new Array();

export const PlasmicRolesCard__ArgProps = new Array("roleName");

const $$ = {};

function PlasmicRolesCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__kPrDl)}>
        <div className={classNames(projectcss.all, sty.freeBox__sodCt)}>
          {renderPlasmicSlot({
            defaultContents: "Admin",
            value: args.roleName,
            className: classNames(sty.slotTargetRoleName)
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__vVES)}>
          <div
            data-plasmic-name={"chipsStack"}
            data-plasmic-override={overrides.chipsStack}
            className={classNames(projectcss.all, sty.chipsStack)}
          >
            <PermissionChip
              className={classNames(
                "__wab_instance",
                sty.permissionChip__mSkas
              )}
            />

            <PermissionChip
              className={classNames(
                "__wab_instance",
                sty.permissionChip__ua82Y
              )}
            />

            <PermissionChip
              className={classNames("__wab_instance", sty.permissionChip__eeOK)}
            >
              {"regenerate api key"}
            </PermissionChip>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__hMpVx)}>
          <Icons8EditSvgIcon
            data-plasmic-name={"editRoleBtn"}
            data-plasmic-override={overrides.editRoleBtn}
            className={classNames(projectcss.all, sty.editRoleBtn)}
            role={"img"}
          />
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "chipsStack", "editRoleBtn"],
  chipsStack: ["chipsStack"],
  editRoleBtn: ["editRoleBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRolesCard__ArgProps,
          internalVariantPropNames: PlasmicRolesCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicRolesCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRolesCard";
  } else {
    func.displayName = `PlasmicRolesCard.${nodeName}`;
  }
  return func;
}

export const PlasmicRolesCard = Object.assign(
  // Top-level PlasmicRolesCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    chipsStack: makeNodeComponent("chipsStack"),
    editRoleBtn: makeNodeComponent("editRoleBtn"),
    // Metadata about props expected for PlasmicRolesCard
    internalVariantProps: PlasmicRolesCard__VariantProps,
    internalArgProps: PlasmicRolesCard__ArgProps
  }
);

export default PlasmicRolesCard;
/* prettier-ignore-end */
